import styled from 'styled-components';

import { sizeUp } from '~/theme';

export const Container = styled.div(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-end',
  gap: '20rem',
  alignItems: 'center',

  paddingBlockStart: sizeUp('15rem', ['lg', '30rem']),
  paddingInlineStart: sizeUp('10rem', ['lg', '30rem']),
  paddingBlockEnd: sizeUp('20rem', ['lg', '40rem']),
  paddingInlineEnd: sizeUp('30rem', ['lg', '60rem']),
}));
